import Vue from "vue";
import base from "./baseIntegration";

export default Object.assign(
    {
        apiUrl: "/external-service/",

        testReceive(id, data) {
            const url = this.url(`${id}/test`);
            return Vue.http.post(url, data);
        },       
       
    },
    base
);
